module.exports = __webpack_public_path__ + "assets/img/teacher (7).a9c9f7cb.png";